import React from 'react'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import { Button } from '../../components/common/common'
import {Container,Row} from 'react-bootstrap'
import Address from './address'
import AboutData from '../../data/about'
import BlockData from '../../data/about/aboutblock'
import AboutBox from '../../components/common/AboutBox'

export function About(props) {
        return (
        <section className="aboutus-wrapper site-margin" id="About">
            <Container> 
                <Row className="aboutus-1 wow bounceInUp">
                    <div className="col-lg-6 col-md-6 col-sm-12 wow rotateInDownLeft"  data-wow-duration="1s">
                        <div className="aboutus-image-block">
                            <img src={require('../../assets/images/aboutus-img.jpg')} alt="" title="" className="about-img" />
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 wow rotateInDownRight" data-wow-duration="1s"  data-wow-delay="500ms">
                        <div className="aboutus-content-block">
                            <div className="site-heading">
                                <h2>{AboutData.heading}</h2>
                                <span>{AboutData.subheading}</span>
                            </div>
                            <div className="aboutus-content-2">
                                <p>{AboutData.content}</p>
                                <Address aboutdata={AboutData}/>
                            </div>
                        </div>
                    </div>
                </Row>
                <div className="aboutus-2 wow bounceInUp" data-wow-offset="50" data-wow-duration="1s" data-wow-delay="0.7s">
                    <div className="row aboutus-year-block">
                        {BlockData.map(data => (
                            <AboutBox key={data.id} aboutBox={"col-lg-3 col-sm-6 " + data.class} aboutIcon={data.icon} heading={data.heading} text={data.text} />
                        )
                       )}
                        <div className="col-lg-3 col-sm-6">
                            <div className="about-year-btn">
                                <Button divclass="allbutton" tagHref="#project" btnClass="btn" spanHover="Download CV" btnName="Download CV"  faIcon={faDownload}/>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </section>
        )
    }
export default About
